exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cam_container {\n  background-color: #f3f4f5;\n  border-radius: 1rem;\n  padding: 1rem;\n}\n.cam_capture-figure {\n  display: block;\n  text-align: center;\n}\n.cam_capture-figure img {\n    width: 175px;\n    height: 175px;\n    object-fit: cover;\n    margin-left: auto;\n    margin-right: auto;\n    border: 1px solid #aaa;\n    padding: 1px;\n}\n", ""]);

// exports
